import React, { useEffect, useRef, useState } from 'react'
import Tools from '../../../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { GameDataConfig, SingleScenarioConfig } from '../../../../cvp-webgames-core/Misc/interfaces';
import { CustomGameDataConfig, CustomGameDataManager, PageType, parseDynamicHtml, setFocus, setLast508WindowId, TextHtmlTagType } from '../../../../misc/tools';
import { BaseConfig } from '../../../BaseConfig';
import Button1 from '../../../general/button1';
import Button2 from '../../../general/button2';
import PopUp1 from '../../../general/pop-up1';
import PopUp2 from '../../../general/pop-up2';
import ProgressBar1 from '../../../general/progress-bar1';

import "./start-scenarios-window.css"
import CoreArrow1 from '../../../../cvp-webgames-core/Components/ui/react/core-arrow1';
import CoreArrow2 from '../../../../cvp-webgames-core/Components/ui/react/core-arrow2';
import AlertUI from '../../../ui/alert-ui';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../../../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import { MainMenuWindow508Type, set508Window } from '../../../../pages/MainMenuPage';
import ProgressBar2 from '../../../general/progress-bar2';


class StartScenariosWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'scenario-hero',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'lock-locked',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/lock-locked.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'lock-unlocked',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/lock-unlocked.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'scen-icon',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/scenario-icon.svg'
			}
		];
	}
}

export const startScenariosWindowCaching = new StartScenariosWindowCaching();

interface SingleScenarioInfoConfig {
    scenarioId: PageType;
}

var heroUrl = startScenariosWindowCaching.getItemByKey('scenario-hero').src;

let scenariosInfo: SingleScenarioInfoConfig[] = [
	
];

Tools.getSaveData().then((savedScenarios: CustomGameDataManager) => {
	for(var i = 0; i < savedScenarios.data.scenarios.length; i++) {
		scenariosInfo.push({
			scenarioId: savedScenarios.data.scenarios[i].scenarioWindow,
		})
	}
})



const getScenarioIndxFromPageType = (pageType: PageType) => {
	for(var indx = 0; indx < scenariosInfo.length; indx++) {
		if(scenariosInfo[indx].scenarioId === pageType) {
			return {indx: indx, info: scenariosInfo[indx]};
		}
	}
}
let modalScenarioIndx: number;
export const getCompletionPercentage = (scenario: SingleScenarioConfig) => {
	// let completedQuestion = scenario.CurrentQuestion-1;
	// if(completedQuestion < 0) {
	// 	completedQuestion = 0;
	// }
	// return completedQuestion / scenario.MaxQuestions;
	return scenario.score / scenario.maxScore;
}
const StartScenariosWindow = (props: StartScenariosWindowConfig) => {
	// const [gameData, setGameData] = useState(null as IvDemoGameDataConfig);
	const [showModal, setShowModal] = useState(false);
	const [showModalCompleted, setShowModalCompleted] = useState(false);
	const [lastScenarioUnlockedIndex, setLastScenarioUnlockedIndex] = useState(-1);
	const [selectedScenarioIndex, setSelectedScenarioIndex] = useState(-1);
	const [forceUpdate, setForceUpdate] = useState(false);
	const root = useRef(null);
	const initialAnimation = props.animation.getInitialClass();
	useEffect(() => {
		// props.animation.updateProps({
		// 	page: root.current
		// });
	}, [root])
	// if(!gameData) {
	// 	getSaveData().then((savedData: IvDemoGameDataManager) => {
	// 		setLastScenarioUnlockedIndex(savedData.data.lastVisitedScenarioIndx);
	// 		setGameData(savedData.data);
	// 	})
	// 	return <div ref={root} style={{}}></div>;
	// }

	const updateSelectedScenarioIndex = (indx: number) => {
		props.animation.setState(AnimationState.Out, ()=> {
			Tools.updateWindow(scenariosInfo[indx].scenarioId);
			// setSelectedScenarioIndex(indx)
		});
	}

	const renderContent = () => {
		return (
			<div ref={root} style={{
				width: '1000px',
				// height: '100%',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)'
			}}>
				<AllScenariosWindow 
					lastScenarioUnlockedIndex={lastScenarioUnlockedIndex}
					allScenarios={props.saveData.scenarios} 
					onReturnToPreviousMenuClicked={() => {
						props.onReturnToPreviousMenuClicked();

						//HACK
						document.getElementById('start-scenarios-root').classList.remove(initialAnimation);
						document.getElementById('start-scenarios-root').classList.add(initialAnimation.replace('in', 'out'));
					}}
					getCompletionPercentage={getCompletionPercentage}
					saveData={props.saveData}
					onScenarioSelected={(pageType: PageType, isNextScenario: boolean) => {
						// getSaveData().then((savedData: IvDemoGameDataManager) => {
							const indx = getScenarioIndxFromPageType(pageType).indx;
							modalScenarioIndx = indx;

							const onDone = () => {
								updateSelectedScenarioIndex(indx);
							}
							if(props.saveData.scenarios[indx].isCompleted) {
								set508Window(MainMenuWindow508Type.AlertUI);
								setShowModalCompleted(true);
							}
							else if(props.saveData.scenarios[indx].CurrentQuestion-1 > 0) {
								set508Window(MainMenuWindow508Type.AlertUI);
								setShowModal(true);
							} else {
								onDone();
							}
						// });
					}}></AllScenariosWindow>
			</div>
		)
	}

	const resetCurrentScenario = () => {
		return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			savedData.data.scenarios[modalScenarioIndx].area = -1;
			savedData.data.scenarios[modalScenarioIndx].aarEntries = [];
			savedData.data.scenarios[modalScenarioIndx].score = 0;
			savedData.data.scenarios[modalScenarioIndx].isCompleted = false;

			return Tools.saveGame(savedData).then(() => {
				return true;
			});
		});
	}

	return (
		<div id='start-scenarios-root' className={"modal-disable-select start-scenarios-window-container center-element " + props.animation.getInitialClass()} style={{
		}}>
			{renderContent()}
			{showModalCompleted ? (
				<AlertUI parameters={{
					htmlContent: `<p>This scenario has already been completed with a passing score. Would you like to restart this scenario? Your previous score will be lost.</p>`,
					okButton: {
						onClick: () => {
							set508Window(MainMenuWindow508Type.Main);
							resetCurrentScenario().then(() => {
								updateSelectedScenarioIndex(modalScenarioIndx);
								setShowModalCompleted(false)
							});
						},
						title: 'Yes'
					},
					noBttn: {
						onClick: () => {
							setShowModalCompleted(false)
						},
						title: 'No'
					},
					title: 'Scenario Already Completed'
				}}></AlertUI>
			) : (null)}
			{showModal ? (
				<AlertUI parameters={{
					htmlContent: `<p>There appears to be another scenario in progress. If you proceed, the saved data for the in progress scenario will be erased. Would you like to proceed?</p>`,
					okButton: {
						onClick: () => {
							set508Window(MainMenuWindow508Type.Main);
							resetCurrentScenario().then(() => {
								updateSelectedScenarioIndex(modalScenarioIndx);
								setShowModal(false)
							});
						},
						title: 'Yes'
					},
					noBttn: {
						onClick: () => {
							setShowModal(false)
						},
						title: 'No'
					},
					title: 'Scenario In Progress'
				}}></AlertUI>
			) : (null)}
		</div>
	);

};

const AllScenariosWindow = (props: AllScenariosWindowConfig) => {
	const selectedScenario = props.allScenarios[props.lastScenarioUnlockedIndex];
	// const [gameData, setGameData] = useState(null as IvDemoGameDataConfig);
	const [focusSet, setFocusSet] = useState(false);
	if(!(window as any)['core-motion-disabled']) {
		setTimeout(() => {
			document.getElementsByTagName('video')[0].play();
		}, 50);
	}
	// getSaveData().then((savedData: IvDemoGameDataManager) => {
	// 	if(savedData.data.isMotionEnabled) {
	// 		setTimeout(() => {
	// 			document.getElementsByTagName('video')[0].play();
	// 		}, 50);
	// 	}

	// 	setGameData(savedData.data);
	// })

	// if(!gameData) {
	// 	return null;
	// }


	if(!focusSet) {
		Tools.getSaveData().then((retrievedData: CustomGameDataManager) => {
			if(retrievedData.data.isAnimationsEnabled) {
				setTimeout(() => {
					setFocus('all-scenarios-window-top');
				}, 1000);
			} else {
				setFocus('all-scenarios-window-top', null, 50);
			}
			
			setFocusSet(true);
		})
	}
	return (
		<div className="modal-disable-select start-scenarios-window-container " style={{
		}}>
			<PopUp1
				title= {constants.projectTitle}
				buttons={[
					{
						imgSrc: startScenariosWindowCaching.getItemByKey('return1').src,
						width: '80%',
						height: '80px',
						buttonText: "Return to Previous Menu",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onReturnToPreviousMenuClicked
					}
				]}
				onRenderContent={() => {
					return (
						<div className='start-scenarios-all-scenarios-container' tabIndex={0} id='all-scenarios-window-top'>
							<div className='center-element-horizontal white-text' style={{
								textAlign:'center',
								width: '100%'
							}}>
								<h1>Start Scenarios</h1>
								<h2>Please select a scenario to start.</h2>
							</div>

							<div className='start-scenarios-scenario-list'>
								{props.saveData.scenarios.map((scenario: SingleScenarioConfig, indx: number) => {
									if(indx === props.lastScenarioUnlockedIndex) {
										return (
											<div tabIndex={0} key={Tools.generateGuid()} className='start-scenarios-last-unlocked-scenario main-content-inner' aria-label={selectedScenario.scenarioWindow.toString() + '. ' + Math.round(props.getCompletionPercentage(selectedScenario) * 100) + '% completed.'}>
												<div className='start-scenarios-last-unlocked-scenario-checkbox-container center-element-vertical'>
													<img alt='' src={startScenariosWindowCaching.getItemByKey('scen-icon').src} />
												</div>
												<p className='start-scenario-scenario-title'>
													{selectedScenario.scenarioWindow.toString()}
												</p>
												<div style={{position: 'relative'}} className='start-scenarios-last-unlocked-scenario-progresss-container center-element-horizontal'>
													<ProgressBar1 title='Scenario Progress' textColor='black' percentage={props.getCompletionPercentage(selectedScenario)}></ProgressBar1>
												</div>
												<div className='start-scenarios-last-unlocked-scenario-continue-bttn'> 
													<Button2 backgroundColor='#157F2F' idFor508={'scenario-list-button-item' + indx} hoverBgColor='#0b491a' ariaLabel='Start Scenario' height='100%' onClick={() => {
														(window as any)['focus-last-el-alert'] = 'scenario-list-button-item' + indx;	
														props.onScenarioSelected(scenariosInfo[props.lastScenarioUnlockedIndex].scenarioId, true);
													}} width='100%' isSelected={false} onRenderContent={(isHovering: boolean) => {
														return (
															<CoreArrow1 isHovering={isHovering} bgColor='white' hoverColor='white'></CoreArrow1>
														);
													}}></Button2>
												</div>
											</div>
										);
									}
									return (
										<div tabIndex={0} key={Tools.generateGuid()} className={scenario.isLocked ? ('start-scenarios-single-scenario-container-locked main-content-inner') : ('start-scenarios-single-scenario-container main-content-inner super-special-container')} aria-label={scenario.scenarioWindow.toString() + '. ' + Math.round(props.getCompletionPercentage(scenario) * 100) + '% completed.'} >
											<div className='start-scenarios-single-scenario-checkbox-container center-element-vertical'>
												<img alt='' src={startScenariosWindowCaching.getItemByKey('scen-icon').src} />
											</div>
											<p className='center-element-vertical start-scenarios-single-scenario-title black-text'>
												{scenario.scenarioWindow.toString()}
											</p>
											<div className='start-scenarios-single-scenario-progresss-container center-element-vertical'>
												{scenario.isComingSoon ? (
													<div style={{
														position: 'absolute',
														width: '100%',
														height: '100%',
														zIndex: 1
													}}>
														<p className='coming-soon-scenario-start'>Coming Soon</p>
													</div>
												) : null } 
												<div style={{
													filter: scenario.isComingSoon ? 'blur(3px)' : undefined
												}}>
													<ProgressBar2 percentage={props.getCompletionPercentage(scenario)}></ProgressBar2>
												</div>
											</div>
											<div className={scenario.isLocked ? ('start-scenarios-single-scenario-continue-bttn') : ('start-scenarios-single-scenario-continue-bttn')}>
												{scenario.isLocked ? (
													<Button2 ariaLabel='Start Scenario' idFor508={'scenario-list-button-item' + indx} height='100%' onClick={() => {
														(window as any)['focus-last-el-alert'] = 'scenario-list-button-item' + indx;	
														props.onScenarioSelected(scenario.scenarioWindow, false);
													}} style={{
														backgroundColor: 'lightgray'
													}}
													isDisabled={scenario.isLocked}
													hoverBgColor={constants.design.hoverColor2}
													width='100%' isSelected={false} onRenderContent={() => {
														return (
															<div className='start-scenarios-single-scenario-continue-bttn-img center-element' style={{width: '27px'}}>
																<img src={startScenariosWindowCaching.getItemByKey(`lock-${scenario.isLocked ? 'locked' : 'unlocked'}`).src} />
															</div>
														);
													}}></Button2>
												) : (
													<div className='main-content-inner'>
														{scenario.isCompleted ? (
															<Button2 ariaLabel='Start Scenario' idFor508={'scenario-list-button-item' + indx} height='100%' onClick={() => {
																(window as any)['focus-last-el-alert'] = 'scenario-list-button-item' + indx;	

																props.onScenarioSelected(scenario.scenarioWindow, false);
															}}
															hoverBgColor={constants.design.hoverColor2}
															width='100%' isSelected={false} onRenderContent={() => {
																return (
																	<span className="scenario-checkmark">
																		<div className="scenario-checkmark_stem"></div>
																		<div className="scenario-checkmark_kick"></div>
																	</span>
																);
															}}></Button2>
														) : (
															<Button2 ariaLabel='Start Scenario' idFor508={'scenario-list-button-item' + indx} height='100%' onClick={() => {
																(window as any)['focus-last-el-alert'] = 'scenario-list-button-item' + indx;	
																props.onScenarioSelected(scenario.scenarioWindow, false);
															}}
															hoverBgColor={constants.design.hoverColor2}
															width='100%' isSelected={false} onRenderContent={() => {
																return (
																	<CoreArrow2></CoreArrow2>
																);
															}}></Button2>
														)}
													</div>
												)}
											</div>
										</div>
									)
								})}
							</div>
						</div>
						);
				}}></PopUp1>
		</div>
	);
};

export interface StartScenariosWindowConfig extends BaseConfig {
	animation: AnimationPage;
	saveData: CustomGameDataConfig;
	onReturnToPreviousMenuClicked: () => void;
	onStartScenarioClicked: (page: PageType, scenarioIndx: number) => void;
	updateWindow: (windowToUse: PageType) => void;
}

export interface AllScenariosWindowConfig {
	saveData: CustomGameDataConfig;
	lastScenarioUnlockedIndex: number;
	allScenarios: SingleScenarioConfig[];
	onReturnToPreviousMenuClicked: () => void;
	getCompletionPercentage: (scenario: SingleScenarioConfig) => number;
	onScenarioSelected: (pageType: PageType, isNextScenario: boolean) => void;
}

export default StartScenariosWindow;